"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginMethod = void 0;
var LoginMethod;
(function (LoginMethod) {
    LoginMethod["Email"] = "email";
    LoginMethod["Phone"] = "phone";
    LoginMethod["Both"] = "both";
})(LoginMethod = exports.LoginMethod || (exports.LoginMethod = {}));
//# sourceMappingURL=SendCareLoginLinkJobInput.js.map